export type TypographyVariant =
  | 'large'
  | 'medium'
  | 'small'
  | 'extraSmall'
  | 'subtitle'

export type TypographyConfig = {
  fontSize: string
  lineHeight?: string
  fontWeight?: number
  isBoldFontWeight?: number
  marginBottom?: string
}

export const typographyStyles: Record<TypographyVariant, TypographyConfig> = {
  large: {
    fontSize: '1.5rem',
    lineHeight: '140%',
    isBoldFontWeight: 700,
    marginBottom: '2rem',
  },
  medium: {
    fontSize: '1.125rem',
    lineHeight: '1.75rem',
    marginBottom: '1.5rem',
  },
  small: {
    fontSize: '0.875rem',
    lineHeight: '1.375rem',
    marginBottom: '1.5rem',
  },
  extraSmall: {
    fontSize: '0.75rem',
  },
  subtitle: {
    fontSize: '1rem',
  },
}
